import React, { useState, useEffect } from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import withRouter from 'src/config/withRouter';
import { save_company, remove_user, save_user, checkParentSessions } from 'src/store/action';
import firebase, { db, getCourseContent, generateContentSignedUrl, revokeAllParentSessions } from 'src/config/firebase';
import CustomMetaData from 'src/hooks/CustomMetaData';
import DotLoader from 'src/components/Utils/DotLoader';
import withStyles from '@mui/styles/withStyles';
import { Backdrop, CircularProgress, Drawer, Dialog, Slide } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { DoneOutline } from '@mui/icons-material';
// components
import withAuth from 'src/screens/Parents/config/WithAuth';
import { _BottomNavigation, WhatsappButton } from '../../components/PageLayout';
import CustomDialog from 'src/components/schooladmit-res-comp/CustomDialog';
import ContentSideMenu from './components/ContentSideMenu';
import Header from '../../components/Header';
import { createMarkup } from 'src/screens/WhiteLabels/Templates/shared/logic/Utils';
import { AlertMessage } from 'src/screens/Partners/Service/components';
import VideoJS from './components/VideoJS';
import QuizRender from './components/quiz/QuizRender';
import PDFViewer from '../../components/PDFViewer';
import DocLogo from 'src/assets/images/groupingContent/file.svg';
import LinkLogo from 'src/assets/images/content/menuLink.svg';
import DownloadLogo from 'src/assets/images/content/download.svg';
import OpenLinkLogo from 'src/assets/images/content/openLink.png';
import ExpireLogo from 'src/assets/images/content/expired.png';
import TextIcon from 'src/assets/images/groupingContent/text.svg';
import TaskIcon from 'src/assets/images/groupingContent/task.svg';
import certificateIcon from 'src/assets/images/parent/certificate_1.png';
import PdfIcon from 'src/assets/images/content/pdf.png'

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ColorCircularProgress = withStyles({
    root: {
      color: '#0F467A',
    },
})(CircularProgress);

const useStyles = makeStyles(theme=> ({

    backdrop: {
        zIndex: 111125,
        color: '#fff',
    },

    //  new style
    container:{
        display: 'flex',
        flex: '1 1 0%',
        minWidth: '0px',
        minHeight: '100%',
        flexDirection: 'column',
    },

    containerInnDiv:{
        display: 'flex',
        flex: '1 1 0%',
        minWidth: '0px',
        minHeight: '100%',
        flexDirection: 'column',
        [theme.breakpoints.between('xs','md')]: {
            flexDirection:'column-reverse'
        }
    },

    headerCustomCls:{
        position:'fixed'
    },

    contentView:{
        width:'calc(100% - 260px)',
        padding:'0px 130px',
        [theme.breakpoints.between('xs','md')]: {
            width:'100%',
            padding:'0px'
        }
    },

    contentInDiv:{
        width:'100%',
        height:'100%'
    },

    titleSpan:{
        fontSize:'18px',
        color:'#000'
    },

    docContentView:{
        width:'calc(100% - 44px)',
        minHeight:'calc(241px - 44px)',
        backgroundColor:'#fff',
        boxShadow:'0px 3px 6px #00000029',
        borderRadius:'10px',
        display:'flex',
        flexDirection:'column',
        padding:'44px 22px',
        position:'relative',
        [theme.breakpoints.between('xs','md')]: {
            padding:'22px',
            borderRadius:'0px'
        }
    },

    taskStatus:{
        borderRadius:'5px',
        padding:'6px 30px',
        position:'absolute',
        top:'44px',
        fontSize:'18px',
        fontWeight:600,
        textTransform:'capitalize',
        [theme.breakpoints.between('xs','md')]: {
            top:'22px',
            fontSize:'14px',
            padding:'6px 10px',
        }
    },

    statusLeft:{
        left:'22px',
        [theme.breakpoints.between('xs','md')]: {
            left:'10px'
        }
    },

    statusRight:{
        right:'22px',
        [theme.breakpoints.between('xs','md')]: {
            right:'10px'
        }
    },

     drawer: {
        width: '240px',
        flexShrink: 0,
    },
    drawerPaper: {
        width: '240px',
        backgroundColor:'#0D273E'
    },

    rowDiv:{
        display:'flex',
        flexDirection:'row'
    },

    docContentIcon:{
        width:'33px',
        height:'33px',

        '& img':{
            width:'100%',
            height:'100%'
        }
    },

    colDiv:{
        display:'flex',
        flexDirection:'column'
    },

    docViewTitle:{
        fontSize:'14px',
        color:'#36ABEF',
        textTransform:'capitalize'
    },

    contentNameSpan:{
        fontSize:'18px',
        color:'#000',
        fontWeight:'bold',
        [theme.breakpoints.between('xs','md')]: {
            display:'none'
        }
    },

    contentNameMBSpan:{
        fontSize:'14px',
        color:'#000',
        fontWeight:'bold',
        display:'none',
        textTransform:'capitalize',
        padding:'0px 10px',
        [theme.breakpoints.between('xs','md')]: {
            display:'block'
        }
    },

    mbViewContentBtn:{
        fontSize:'14px',
        color:'#0F467A',
        display:'none',
        textTransform:'capitalize',
        padding:'0px 10px',
        display:'none',
        cursor:'pointer',
        [theme.breakpoints.between('xs','md')]: {
            display:'block'
        }
    },

    contentDesc:{
        color:'#000',
        marginTop:'13px',
        [theme.breakpoints.between('xs','md')]: {
            display:'none'
        }
    },

    // bottomNavCls:{
    //     display:'none',
    //     [theme.breakpoints.between('xs','sm')]: {
    //         display:'flex'
    //     }
    // },

    downLogo:{
        width:'67px',
        height:'67px',
        marginTop:'15px',

        '& img':{
            width:'100%',
            height:'100%'
        }
    },

    docLinkOpenSpan:{
        fontSize:'18px',
        color:'#000',
        marginTop:'13px'
    },

    marLeft45:{
        marginLeft:'45px'
    },

    marRight45:{
        marginRight:'45px'
    },

    prevNextBtn:{
        backgroundColor:'#0F467A',
        color:'#fff',
        textAlign:'center',
        height:'37px',
        minWidth:'96px',
        boxShadow:'0px 3px 6px #00000029',
        border:'none',
        borderRadius:'5px',
        textTransform:'capitalize',
        cursor:'pointer',
        outline:'none',
    },

    completeBtn:{
        backgroundColor:'#24AC5A',
        color:'#fff',
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'center',
        fontWeight:600,
        height:'40px',
        padding:'10px',
        marginTop:'20px',
        [theme.breakpoints.down('md')]: {
            marginLeft:'auto !important',
            marginRight:'auto !important',
            width:'90%'
        }
    },

    topMainContainer:{
        display: 'flex',
        minWidth: '0px',
        flex: '1 1 0%',
        flexDirection: 'column',
        minHeight: '100%',
        marginTop:'80px',
        [theme.breakpoints.down('md')]: {
            marginLeft: '0px !important',
            marginRight: '0px !important',
            marginTop:'75px',
            minHeight:'unset',
            overflow:'scroll'
        }
    },

    mainInnContainer:{
        display: 'flex',
        minWidth: '0px',
        flex: '1 1 0%',
        flexDirection: 'column',
        alignItems:'center',
    },

    arTopMainContainer: {
        transition: 'margin-right 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        marginRight: '307px',
    },

    enTopMainContainer: {
        transition: 'margin-left 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        marginLeft: '307px',
    },

    btnsDiv:{
        alignItems:'center',
        justifyContent:'space-between',
        width:'100%',
        marginTop:'67px',
        [theme.breakpoints.between('xs','md')]: {
            padding:'0px 10px',
            marginTop:'11px',
            width:'calc(100% - 20px)'
        }
    },

    expireImg:{
        width:'200px',
        height:'200px',
        marginBottom:'30px',

        '& img':{
            width:'100%',
            height:'100%'
        }
    },

    drawerMbCustomCls:{
        [theme.breakpoints.between('xs','md')]: {
            display:'none'
        }
    },

    expireSpan:{
        fontSize:'18px',
        color:'#e63850',
        fontWeight:300,
        textAlign:'center'
    },

    taskTitle:{
        color:'#000000',
        fontSize:'18px',
        [theme.breakpoints.between('xs','md')]: {
            fontSize:'14px'
        }
    },

    fileName:{
        width:'30%',
        padding:'0px 10px',
        whiteSpace:'nowrap',
        overflow:'hidden',
        textOverflow:'ellipsis',
        [theme.breakpoints.between('xs','md')]: {
            width:'calc(100% - 80px)',
            fontSize:'14px'
        }
    },

    downloadBtn:{
        backgroundColor:'transparent',
        outline:'none',
        border:'none',
        color:'#36ABEF',
        fontSize:'14px',
        cursor:'pointer'
    },

    taskFileIcon:{
        width:'19px',
        height:'19px',
        '& img':{
            width:'100%',
            height:'100%',
        }
    },

    mobileViewDialog:{
        borderRadius:'28px',
        '&.MuiDialog-paper':{
            [theme.breakpoints.down('sm')]: {
                margin:'32px 5px !important',
                width:'calc(100% - 10px) !important'
            }
        }
    },

    dialogContentCls:{
        padding:'8px 24px !important',
        [theme.breakpoints.down('sm')]: {
            padding:'8px 12px !important'
        }
    },

    dialogActionCls:{
        display:'none'
    },

    upgradeDialogTitle:{
        color:'#000',
        fontSize:'20px',
        textAlign:'left',
        fontWeight:500
    },

    _saveBtn:{
        backgroundColor:'#0F467A',
        color:'#fff',
        fontSize:'16px',
        fontWeight:'bold',
        borderRadius:'50px',
        border:'none',
        outline:'none',
        padding:'13px',
        marginTop:'5px',
        cursor:'pointer',
        alignSelf:'center',
        textTransform:'uppercase',
        width:'calc(100% - 26px)'
    },

    saveBtn2:{
        width:'119px',
        borderRadius:'5px',
        boxShadow:'0px 3px 6px #00000029',
        alignSelf:'flex-end',
        fontSize:'14px'
    },

    dialogDiv:{
        width: 'calc(100% - 10px)',
        display: 'flex',
        padding: '20px 5px !important',
        flexDirection: 'column',
        position:'relative',
        backgroundColor:'#fff !important'
    },

    dialogRootCustomCls:{
        zIndex:'1600 !important',

        '& .MuiBackdrop-root':{
            display:'none'
        }
    },

    blurContainer:{
        position: 'absolute',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        background:'white',
        backdropFilter: "blur(20px) saturate(70%)",
        background: 'rgb(255 253 253 / 80%)',
        filter: 'blur(20px)',
        '-o-filter': 'blur(20px)',
        '-ms-filter': 'blur(20px)',
        '-moz-filter': 'blur(20px)',
        '-webkit-filter': 'blur(20px)',
        zIndex:1500
    },

    input:{
        display: 'block',
        padding: '5px 14px',
        fontFamily: "'Poppins', sans-serif",
        fontSize: '16px',
        outline: 0,
        borderRadius: '3px',
        backgroundColor: '#FFF',
        border:'1px solid #ABAEB5',
        width:'calc(100% - 28px)',
        [theme.breakpoints.down('lg')]:{
            padding: '10px 5px',
            width:'calc(100% - 10px)'
		}
    },

    label:{
        color:'#000000',
        fontSize:'14px',
        width:'100%',
        [theme.breakpoints.down('lg')]:{
            width:'fit-content'
        }
    }
}));

function CourseContent(props) {
    const { history, user, company, store_user, t, i18n, params, singleSession, company_id } = props;
    const userId = user?.id || '';
    const classes = useStyles();
    // name dialog state
    const [showNameDialog,setShowNameDialog] = useState(false);
    const [name,setName] = useState('');
    const [email,setEmail] = useState('');
    const [nameDialogLoader,setNameDialogLoader] = useState(false);

    const [walletValue,setWalletValue] = useState('');
    const [walletCurrency,setWalletCurrency] = useState('');
    const [alertType,setAlertType] = useState('');
    const [message,setMessage] = useState('');
    const [open,setOpen] = useState(false);
    const [openAlert,setOpenAlert] = useState(false);
    const [companySetting,setCompanySetting] = useState({});
    const [loading,setLoading] = useState(false);
    const [contentLoading,setContentLoading] = useState(false);
    const [userLoader,setUserLoader] = useState(false);
    const [walletLoader,setWalletLoader] = useState(false);

    const [courseData,setCourseData] = useState({});
    const [courseId,setCourseId] = useState('');
    const [courseContents,setCourseContents] = useState([]);
    const [contentId,setContentId] = useState('');
    const [expandId,setExpandId] = useState('');
    const [studentName,setStudentName] = useState('');
    const [studentEmail,setStudentEmail] = useState('');

    // student log state
    const [expire,setExpire] = useState(false);
    const [studentLogId,setStudentLogId] = useState('');
    const [studentLogData,setStudentLogData] = useState({});
    const [contentLogs, setContentLogs] = useState([]);
    const [studentLogLoader,setStudentLogLoader] = useState(false);
    const [contentLogLoader,setContentLogLoader] = useState(false);
    const [disableDialog,setDisableDialog] = useState(true);

    const [sessionLoader,setSessionLoader] = useState(false);

    const isRTL = i18n.translator.language;
    const ar = "'Cairo', sans-serif";
    const en = "'Poppins', sans-serif";
    const fontFamily = isRTL === 'ar' ? ar : en;
    const whatsappNumber = company?.whatsappNumber || '';
    const { showMobileBottomNav = true } = companySetting || {};

    useEffect(() => {
        // ❌ Disable Right Click
        const disableRightClick = (event) => event.preventDefault();
        document.addEventListener("contextmenu", disableRightClick);
    
        // ❌ Disable Keyboard Shortcuts (Windows + Mac)
        const disableKeyboardShortcuts = (event) => {
            console.log('event',event)
          if (
            event.key === "F12" || 
            (event.ctrlKey && event.shiftKey && (event.key === "I" || event.key === "J" || event.key === "∆" || event.key === "C" || event.key === "U" || event.key === "S")) || 
            (event.metaKey && event.altKey && (event.key === "I" || event.key === "J" || event.key === "∆" || event.key === "C" || event.key === "U" || event.key === "S")) || 
            (event.ctrlKey && event.key === "U") || 
            (event.metaKey && event.key === "U") || 
            (event.key === "Escape")  // Prevents DevTools on some browsers
          ) {
            event.preventDefault();
            return false;
          }
        };
        document.addEventListener("keydown", disableKeyboardShortcuts);
    
        // ❌ Detect DevTools (Via Console.log Debugging)
        const detectDevTools = () => {
          const element = new Image();
          element.__defineGetter__("id", function () {
            alert("Developer tools detected! Please close them.");
            window.location.reload();
          });
          console.log("%c", element);
        };
        detectDevTools();
    
        // ❌ Detect DevTools (Resize Trick)
        const checkDevToolsOpen = () => {
          if (window.outerWidth - window.innerWidth > 200 || window.outerHeight - window.innerHeight > 200) {
            alert("Developer tools detected! Please close them.");
            window.location.reload();
          }
        };
        const devToolsChecker = setInterval(checkDevToolsOpen, 1000);
    
        // Cleanup on Unmount
        return () => {
          document.removeEventListener("contextmenu", disableRightClick);
          document.removeEventListener("keydown", disableKeyboardShortcuts);
          clearInterval(devToolsChecker);
        };
    }, []);
    

    useEffect(()=> {
        async function RunAction(){
            if(!user) {
                history.push('/')
            }
            if(user && !user.isParent) {
                history.push('/dashboard')
            }
            else{
                const id = params.id ? params.id : '';
                const ownerId = id ? await (await db.ref(`Reservations/${id}/owner`).once('value')).val() : '';
                if(userId !== ownerId) {
                    showAlert('Cannot access course content','error');
                    setTimeout(()=> history.goBack(),1000)
                }
                else{
                    props._checkParentSessions(user.id);
                    getUserLastedData();
                    getTemplateSetting();
                    getCourseData();
                }
            }
            // window.addEventListener('contextmenu', function (e) {
            //     e.preventDefault();
            // });
        };

        RunAction();
    },[]);

    useEffect(()=> {

        getStudentLog();
        getContentLogEvent();

    },[studentLogId,courseId])

    const getCourseData = async  () => {
        const id = params.id ? params.id : '';
        if(id) {
            setLoading(true);
            db.ref(`Reservations/${id}/`).once('value',async (data)=> {
                let responseData = data.val();
                const courseId = responseData?.courseId;
                const studentLogId = responseData?.courseLogId || '';
                const isExpire = responseData?.dateEnd !== undefined ? responseData?.dateEnd < moment().unix() : false;
                const studentName = responseData?.kidName || '';
                const studentEmail = responseData?.email || '';
                if(studentName) setName(studentName);
                if(studentEmail) setEmail(studentEmail);

                setExpire(isExpire);
                if(!isExpire) {
                    if(studentLogId) {
                        setStudentLogId(studentLogId);
                    };
    
                    if(courseId) {
                        setStudentName(studentName);
                        setStudentEmail(studentEmail);
                        const courseData = await (await db.ref(`Courses/${courseId}`).once('value')).val();
                        if(courseData) setCourseData(courseData);
                        setCourseId(courseId);
                        getContents(courseId,courseData,studentLogId);
                    }
                };
                setLoading(false);
            })
        }
    };

    const getContentLogEvent = async () => {
        if(studentLogId) {
            setContentLogLoader(true);
            db.ref(`ContentLogs/`).orderByChild('logId').equalTo(studentLogId).on('value',(data)=> {
                let logData = data.val();
                if(logData && Object?.keys(logData)?.length) {
                    let array = [];
                    Object?.values(logData).forEach(v=> array.push(v));
                    setContentLogs(array || []);
                    setContentLogLoader(false);
                }
                else{
                    setContentLogLoader(false);
                    setContentLogs([]);
                }
            });
        }
    };

    const getStudentLog = async (logId) => {
        if(studentLogId) {
            const isCertificateEnable = courseData ? courseData?.autoGenerateCertificate : false;
            setStudentLogLoader(true);
            db.ref(`StudentCourseLogs/${studentLogId}`).on('value',(data)=> {
                let logData = data.val();
                if(logData) {
                    setStudentLogData(logData);
                    setExpandId(logData.currentSectionId);
                    setContentId(logData.currentContentId)
                    setStudentLogLoader(false);
                    if((!logData?.email || !logData?.studentName) && isCertificateEnable) {
                        setShowNameDialog(true);
                    };
                }
                else{
                    setStudentLogLoader(false);
                    setStudentLogData({});
                }
            });
        }
    };

    const createStudentLog = async (courseData,contentData,courseId) => {
        let promise = [];
        const companyId = company && company.id || '';
        const userId = user ? user?.id : '';
        const resId = params.id ? params.id : '';
        if(courseData && resId) {
            const sections = courseData?.['Sections']?.length ? courseData?.['Sections'].filter(v=> v?.visible) : [];
            if(sections) {
                const { sectionId, contentId } = getFirstVisibleContentInfo(sections,contentData)

                if(sectionId && contentId) {
                    setExpandId(sectionId);
                    setContentId(contentId);

                    const dataObj = {
                        companyId,
                        userId,
                        courseId,
                        reservationId: resId,
                        currentSectionId: sectionId,
                        currentContentId: contentId,
                        createdAt: moment().unix(),
                    };

                    var nodeId = (await db.ref('StudentCourseLogs').push()).key;
                    var contentNodeId = (await db.ref('ContentLogs').push()).key;

                    dataObj.id = nodeId;

                    const logObj = {
                        companyId,
                        id:contentNodeId,
                        logId: nodeId,
                        contentId,
                        completed:false,
                        downloaded:false,
                        clicked:true,
                        currentDuration:0
                    };

                    promise.push(db.ref(`StudentCourseLogs/${nodeId}`).set(dataObj));
                    promise.push(db.ref(`ContentLogs/${contentNodeId}`).set(logObj));

                    Promise.all(promise)
                    .then(()=> {
                        setStudentLogId(nodeId);
                        if(resId) db.ref(`Reservations/${resId}/courseLogId/`).set(nodeId);
                    })
                    .catch(e=> {
                        console.log('create student log',e.message)
                    })
                }
            };
        }
    };

    const getContents = async (courseId,courseData,studentLogId) => {
        if(courseId) {
            setLoading(false);
            setContentLoading(true);
            getCourseContent({courseId})
            .then(async res=> {
                if(res?.length) {
                    setCourseContents(res || []);
                    if(courseData && res?.length && !studentLogId) {
                        createStudentLog(courseData,res,courseId);
                    };
                };
                setContentLoading(false);
            })
            .catch(e=> {
                setContentLoading(false);
                setCourseContents([]);
                console.log('getCourseContent error',e);
            })
        }
    };

    const getTemplateSetting = () => {
        // get company template setting
        const companyId = company && company?.id || '';
        if(companyId) {
          db.ref('TemplateSettings/')
            .orderByChild('companyId')
            .equalTo(companyId)
            .on('value', (data) => {
                const templateData = data.val();
                if (templateData && Object.values(templateData)[0] !== null) {
                    setCompanySetting(Object.values(templateData)[0]);
                }
                else {
                    setCompanySetting({})
                }
            })
        }
    };

    const getUserLastedData = () => {
        const userId = user?.id || '';
        if(userId) {
            setUserLoader(true);
            db.ref(`Users/${userId}/`).on('value',(data)=> {
                const res = data.val();
                if(res) {
                    res.isParent = true;
                    store_user(res);
                    getWallet();
                }
                setUserLoader(false);
            })
        }
    };

    const getWallet = () => {
        const parentId = user && user.id;
        const companyId = company && company.id;

        if(parentId && companyId) {
            setWalletLoader(true);
            db.ref(`ParentsWallets/`).orderByChild('parentId').equalTo(parentId).on('value',(data)=>{
                const wallet = data.val();
                let walletList = [];
                if(wallet) {
                    for(var i in wallet) {
                        if(wallet[i].companyId === companyId) {
                            walletList.push(wallet[i])
                        }
                    };
                    if(walletList.length > 0) {
                        setWalletValue(walletList[0].walletValue ? walletList[0].walletValue : '');
                        setWalletCurrency(walletList[0].currency ? walletList[0].currency : '');
                        setWalletLoader(false);
                    }
                    else{
                        setWalletValue('');
                        setWalletCurrency('');
                        setWalletLoader(false);
                    }
                }
                else{
                    setWalletValue('');
                    setWalletCurrency('');
                    setWalletLoader(false);
                }
            })
        }
    }

    const showAlert = (message,alertType) => {
        setMessage(message);
        setAlertType(alertType);
        setOpenAlert(true)
    };
    const closeAlert = () => {
        setMessage('');
        setAlertType('');
        setOpenAlert(false);
    };

    const nextPrevBtnEvent = async contentId => { 
        const companyId = company?.id || '';
        let promise = [];
        if(contentId) {
            const sectionId = courseData?.['Sections']?.length ? courseData?.['Sections']?.filter(v=> v?.['contentList']?.includes(contentId))?.[0]?.id : '';

            setContentId(contentId);
            setExpandId(sectionId);

            if(studentLogId) {
                const isExist = contentLogs?.length ? contentLogs?.filter(v=> v.contentId === contentId)?.length : '';
                if(!isExist) {
                    const activeContent = contentId && courseContents?.length ? courseContents.filter(v=> v.id === contentId)?.[0] : {};
                    const { fileType: contentType } = activeContent || {};

                    var contentNodeId = (await db.ref('ContentLogs').push()).key;
                    let contentObj = {
                        companyId,
                        id: contentNodeId,
                        logId: studentLogId,
                        contentId,
                        contentType,
                        completed:false,
                        downloaded:false,
                        clicked:true,
                        currentDuration:0
                    };

                    promise.push(db.ref(`ContentLogs/${contentNodeId}`).set(contentObj));
                };
                let obj = {
                    currentSectionId:sectionId,
                    currentContentId:contentId,
                    updatedAt: moment().unix()
                };
                
                promise.push(db.ref(`StudentCourseLogs/${studentLogId}/`).update(obj));

            };
            return Promise.all(promise);
        };
    };

    const sideMenuContentClick = async (contentId,contentType) => { 
        const companyId = company?.id || '';
        let promise = [];
        if(contentId) {
            const sectionId = courseData?.['Sections']?.length ? courseData?.['Sections']?.filter(v=> v?.['contentList']?.includes(contentId))?.[0]?.id : '';
            setContentId(contentId);
            setExpandId(sectionId);
            setOpen(false);
            if(studentLogId) {
                const isExist = contentLogs?.length ? contentLogs?.filter(v=> v.contentId === contentId)?.length : '';

                if(!isExist) {
                    var contentNodeId = (await db.ref('ContentLogs').push()).key;

                    let contentObj = {
                        companyId,
                        id: contentNodeId,
                        logId: studentLogId,
                        contentId,
                        contentType: contentType || '',
                        completed:false,
                        downloaded:false,
                        clicked:true,
                        currentDuration:0
                    };


                    promise.push(db.ref(`ContentLogs/${contentNodeId}`).set(contentObj));
                }
                
                let obj = {
                    currentSectionId:sectionId,
                    currentContentId:contentId,
                    updatedAt: moment().unix()
                };
                
                promise.push(db.ref(`StudentCourseLogs/${studentLogId}/`).update(obj));

            };
            return Promise.all(promise);
        };
    };

    const downloadLinkClick = contentId => {
        
        if(contentLogs && contentId) {
            const nodeId = contentLogs.filter(v=> v.contentId === contentId)?.[0]['id'] || '';
            db.ref(`ContentLogs/${nodeId}/`).update({downloaded:true,completed:true});
        }
    };

    const pdfFileUpdation = (contentId,data) => {
        
        if(contentLogs && contentId) {
            const nodeId = contentLogs.filter(v=> v.contentId === contentId)?.[0]['id'] || '';
            const { downloaded, completed } = contentLogs.filter(v=> v.contentId === contentId)?.[0] || '';
            db.ref(`ContentLogs/${nodeId}/`).update({...data,downloaded: downloaded !== undefined ? downloaded : data.downloaded,completed: completed !== undefined ? completed : data.completed});
        }
    };

    const onCloseDisableDialog = (_,reason) => {
        if(reason !== 'backdrop') {
            setDisableDialog(false);
        }
    };

    const onCloseNameDialog = (_,reason) => {
        if(reason !== 'backdrop') {
            setShowNameDialog(false);
        }
    };

    const logoutallSession = () => {
        const uid = user?.id || '';
        const copyComp = Object.assign({},company);
        const companyId = company_id?.slice();
        const host = window.location.host;
        const domain = copyComp && copyComp.domain ? copyComp.domain : '';
        const urlName = copyComp && copyComp.urlName ? copyComp.urlName : '';

        if(uid) {
            setSessionLoader(true);
            revokeAllParentSessions({uid})
            .then(async res=> {
                setSessionLoader(false);
                firebase.auth().signOut();
                history.push(domain === host ? '/': urlName ? `/${urlName}` : `/company/${companyId}`)
                props.logout_user();
            })
            .catch(errMsg=> {
                setSessionLoader(false);
                console.log('logoutallSession error',errMsg)
                showAlert(errMsg,'error');
            })
        }
    };

    const updateContentDurationEvent = (duration,contentId,completed) => {
        
        if(contentLogs && contentId) {
            const nodeId = contentLogs?.filter(v=> v.contentId === contentId)?.[0]['id'] || '';
            db.ref(`ContentLogs/${nodeId}/`).update({currentDuration:duration,...(completed ? {completed:true} : {})});
        }
    };

    const markAsCompleteEvent = (contentId,nextContentId) => {
        const currentTime = moment().unix();
        const contentLogId = (contentLogs?.length && contentId) ? contentLogs?.filter(v=> v.contentId === contentId)?.[0]?.id : '';
        if(contentId) {
            setLoading(true);
            db.ref(`ContentLogs/${contentLogId}/`).update({completed:true, completedAt: currentTime,updatedAt:currentTime})
            .then(()=> {
                if(nextContentId) nextPrevBtnEvent(nextContentId);
                setLoading(false);
                showAlert(t && t('coursePage.markAsCompleteSuccess'),'success');
            })
            .catch(e=> {
                setLoading(false);
                showAlert(e.message,'error');
            })
        }
    };

    const saveStudentDetails = () => {
        const email_patt = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if(!studentLogId) {
            showAlert('No log found!','error')
        }
        else if(!studentName) {
            showAlert(t('courses.studentNameAlert'),'error')
        }
        else if(!email_patt.test(email)) {
            showAlert(t('profile-comp.alert.two'),'error');
        }
        else{
            setNameDialogLoader(true);
            db.ref(`StudentCourseLogs/${studentLogId}`).update({studentName,email})
            .then(()=> {
                setNameDialogLoader(false);
                showAlert(t('courses.studentInfoAlert'),'success');
                onCloseNameDialog();
            })
            .catch(e=> {
                setNameDialogLoader(false);
                showAlert(e.message,'error')
            })
        }
    }

    const activeContent = contentId && courseContents?.length ? courseContents.filter(v=> v.id === contentId)?.[0] : {};
    let visibleContentIds = courseContents?.filter(content => content.visible).map(content => content.id);
    const contentIds = courseData?.['Sections']?.length ? courseData?.['Sections'].reduce((acc, section) => {
        if (section.visible && section.contentList && Array.isArray(section.contentList)) {
            acc.push(...section.contentList.filter(id => visibleContentIds.includes(id)));
        }
        return acc;
    }, [])
    :
    [];

    // console.log('studentsLogId',studentLogId)
    
    var index = contentIds.indexOf(contentId);
    const nextContentId = index >= 0 && index < contentIds.length - 1 ? contentIds[index+1] : '';
    const prevContentId = index >= 0 && index < contentIds.length + 1 ? contentIds[index-1] : '';
    const duration = ((contentLogs?.length && contentId) && contentLogs?.filter(v=> v.contentId === contentId)?.length) ? contentLogs?.filter(v=> v.contentId === contentId)?.[0]?.['currentDuration'] : 0;
    return(
        <>
        <CustomMetaData
            {...{
                title: courseData && courseData?.seoTitle ? `${courseData?.seoTitle}` : `My course ${courseData?.name ? ` - ${courseData?.name}` : ''}`,
                image: company && company.avatar,
                description: courseData?.seoMetaDescription ? courseData?.seoMetaDescription : company?.description || '',
                child:<style>{'body { background-color: #F3F7FD; } #root { min-height: 100vh;display: flex;min-width: 0;width: 100%;height: 100%'}</style>
            }}
        />
        <div dir={isRTL === 'ar' ? 'rtl' :'ltr'} className={classes.container}>
            <div className={`${classes.containerInnDiv}`}>
                {!expire ?
                <ContentSideMenu 
                    {...{fontFamily,customCls:classes.drawerMbCustomCls,courseData,courseContents,expandId,setExpandId,activeContentId:contentId,sideMenuContentClick,studentLogData,contentLogs,singleSession,...props}}
                />
                : null}

                <Drawer
                        className={classes.drawer}
                        variant="persistent"
                        anchor={isRTL === 'ar' ? 'right' : 'left'}
                        dir={isRTL === 'ar' ? 'rtl' : 'ltr'}
                        open={open}
                        classes={{
                        paper: classes.drawerPaper,
                        }}
                >
                    <ContentSideMenu 
                        {...{fontFamily,courseData,mobileCloseDrawerEvent: ()=> setOpen(false),courseContents,expandId,setExpandId,activeContentId:contentId,sideMenuContentClick,studentLogData,contentLogs,singleSession,...props}}
                    />
                </Drawer>

                

                <Header mobileTitle={courseData ? isRTL === 'ar' ? courseData?.arName || courseData?.enName : courseData?.enName : 'My Course'} walletValue={walletValue || ''} hideCart={true} customCls={classes.headerCustomCls} walletCurrency={walletCurrency || ''} />
                {!expire ?
                <div className={`${classes.topMainContainer} ${isRTL === 'ar' ? classes.arTopMainContainer : classes.enTopMainContainer}`}>

                    <div className={classes.mainInnContainer}>
                        <div className={classes.contentView}>
                        {contentId && activeContent ?
                            <div className={classes.contentInDiv}>
                                <span className={`${classes.mbViewContentBtn}`} onClick={()=> setOpen(true)} style={{fontFamily}}>{t('coursePage.courseContent')}</span>
                                <span className={classes.contentNameMBSpan} style={{fontFamily}}>{activeContent?.name}</span>
                                {activeContent.fileType === 'video' ?
                                <VideoRender {...{file:activeContent?.file,duration,contentId:activeContent?.id,updateContentDurationEvent,studentEmail,studentName}} />
                                :
                                activeContent.fileType === 'quiz' ?
                                // <span>quiz</span>
                                <QuizRender
                                    quizId={activeContent.quizId}
                                    content={activeContent}
                                    contentLogs={contentLogs}
                                    nextContentId={nextContentId}
                                    prevContentId={prevContentId}
                                    nextPrevBtnEvent={nextPrevBtnEvent}
                                />
                                :
                                <ContentDocumentView 
                                    {...{
                                        t,
                                        isRTL,
                                        fontFamily,
                                        content: activeContent,
                                        downloadLinkClick,
                                        pdfFileUpdation,
                                        contentLogs: contentLogs || [],
                                        ...props
                                    }}
                                />
                                }
                                {activeContent.fileType !== 'quiz' ? 
                                <>
                                {!activeContent?.completed ? 
                                <button style={{fontFamily,...(isRTL === 'ar' ? {marginRight:'auto'} : {marginLeft:'auto'})}} className={`${classes.prevNextBtn} ${classes.completeBtn}`} onClick={()=> markAsCompleteEvent(contentId,nextContentId)}>   
                                    <DoneOutline style={isRTL === 'ar' ? {paddingLeft:'5px'} : {paddingRight:'5px'}}/>
                                    <span>{t('coursePage.markAsComplete')}</span>
                                </button>
                                : null}
                                
                                <div className={`${classes.rowDiv} ${classes.btnsDiv}`}>
                                    <button style={{fontFamily,opacity:!prevContentId ? 0.4 : 1, cursor: !prevContentId ? 'not-allowed' : 'pointer',...(!singleSession ? {pointerEvents:'none'} : {})}} className={classes.prevNextBtn} onClick={()=> nextPrevBtnEvent(prevContentId)}>{isRTL === 'ar' ? '< Previous' : '< Previous'}</button>
                                    <button style={{fontFamily,opacity:!nextContentId ? 0.4 : 1, cursor: !nextContentId ? 'not-allowed' : 'pointer',...(!singleSession ? {pointerEvents:'none'} : {})}} className={classes.prevNextBtn} onClick={()=> nextPrevBtnEvent(nextContentId)}>{isRTL === 'ar' ? 'Next >' : 'Next >'}</button>
                                </div>

                                <p className={classes.contentNameSpan} style={{fontFamily}}>{activeContent?.name || ''}</p>

                                {activeContent?.description ? <span className={`${classes.docViewTitle} ${classes.contentDesc}`} style={{fontFamily}}>{activeContent?.description}</span> : null}
                                </>
                                : null}
                            </div>
                        : null}
                        </div>
                    </div>
                </div>
                : 
                <div className={`${classes.topMainContainer}`}>

                    <div className={classes.mainInnContainer}>
                        <div className={classes.contentView} style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center'}}>
                            <div className={classes.expireImg}>
                                <img src={ExpireLogo} alt='expire' />
                            </div>
                            <span className={classes.expireSpan} style={{fontFamily}}>{t && t('coursePage.expireContent')}</span>
                        </div>
                    </div>
                </div>
                }
            </div>

            <Backdrop className={classes.backdrop} open={walletLoader || userLoader || loading || contentLoading || studentLogLoader || contentLogLoader}>
                <ColorCircularProgress />
            </Backdrop>

            <AlertMessage
                {...{
                    alertType,message,snackOpen:openAlert,
                    closeAlert: closeAlert
                }}
            />

        {/* {showMobileBottomNav ?
            <_BottomNavigation {...{whatsappNumber,fontFamily,showAlert: showAlert,padding:'5.2rem',...props}}/>
        : null} */}
        </div>

         <CustomDialog
                onClose={()=> onCloseNameDialog('','backdrop')}
                open={showNameDialog} 
                title={''}
                maxWidth={'sm'}
                customClasses={{paper:classes.mobileViewDialog}}
                contentCustomCls={classes.dialogContentCls}
                actionCustomCls={classes.dialogActionCls}
                dialogRootCustomCls={classes.dialogRootCustomCls}
            >
            <div className={classes.dialogDiv}>
                <>
                    <div className={classes.rowDiv}>
                        <span className={classes.titleSpan} style={{fontFamily}}>
                            {t('courses.courseStudentInfoDetail')}
                        </span>
                        <img src={certificateIcon} alt='certificate' /> 
                    </div>

                    <span className={classes.label} style={{fontFamily,marginTop:'24px'}}>{t('courses.stdName')}*</span>
                    <input
                        type="text"
                        value={name}
                        onChange={e=> setName(e.target.value)}
                        className={classes.input}
                        style={{marginBottom:'5px'}}
                    />

                    <span className={classes.label} style={{fontFamily,marginTop:'28px'}}>{t('courses.stdEmail')}*</span>
                    <input
                        type="email"
                        value={email}
                        onChange={e=> setEmail(e.target.value)}
                        className={classes.input}
                        style={{marginBottom:'5px'}}
                    />

                    <button className={`${classes._saveBtn} ${classes.saveBtn2}`} style={{fontFamily,marginTop:'43px'}} onClick={saveStudentDetails}>
                    {nameDialogLoader ? <DotLoader /> : t && t('comp-comp.save')}
                    </button>
                </>
            </div>
        </CustomDialog>

        {!singleSession ? <div className={classes.blurContainer}></div> : null}
            <CustomDialog
                onClose={()=> onCloseDisableDialog('','backdrop')}
                open={!singleSession} 
                title={''}
                maxWidth={'xs'}
                customClasses={{paper:classes.mobileViewDialog}}
                contentCustomCls={classes.dialogContentCls}
                actionCustomCls={classes.dialogActionCls}
                dialogRootCustomCls={classes.dialogRootCustomCls}
            >
                <div className={classes.dialogDiv}>
                    <>
                        <span className={classes.upgradeDialogTitle} style={{fontFamily,fontSize:'16px',textAlign:'center'}}>{t('coursePage.multipleSession')}</span>

                        <button className={classes._saveBtn} style={{fontFamily,marginTop:'20px'}} onClick={logoutallSession}>
                        {sessionLoader ? <DotLoader /> : t && t('coursePage.multipleSessionBtn')}
                        </button>
                    </>
                </div>
            </CustomDialog>

        <WhatsappButton whatsappNumber={whatsappNumber} isRTL={isRTL}/>
        </>
    )
}

const mapStateToProps = state => {
    return {
        user: state.user,
        company:state.company,
        company_id: state.company_id,
        singleSession: state.singleSession,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        store_comp : company => dispatch(save_company(company)),
        logout_user : () => dispatch(remove_user()),
        store_user : user => dispatch(save_user(user)),
        _checkParentSessions : (uid) => dispatch(checkParentSessions(uid))
    }
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(withTranslation('common')(withAuth(CourseContent))));

const ContentDocumentView = (props)=> {
    const { t, fontFamily, isRTL, content, taskStatus, downloadLinkClick, pdfFileUpdation,contentLogs,showName=true, singleSession, bookingContent=false } = props;
    const classes = useStyles();
    const [openPdfDialog,setPdfDialog] = useState(false);
    const [pdfFile,setPdfFile] = useState('');


    const RTLMar45 = isRTL === 'ar' ? classes.marRight45 : classes.marLeft45;
    const { fileType, name, file, id, text, dueDate,description, protectFile } = content || {};

    const taskStatusColors = {
        "grade":{
            color: '#54b7f1',
            border: '#82cbf5',
            bgColor: '#d9f1ff',
            label: t('groupings.graded')
        },
        "overdue":{
            color: '#aa320f',
            border: '#fd8c59',
            bgColor: '#f7cab2',
            label: t('groupings.overdue')
        },
        "pending":{
            color: '#bf8917',
            border: '#fdd359',
            bgColor: '#f7e9b2',
            label: t('groupings.pending')
        },
        "submitted":{
            color: '#249766',
            border: '#59fda1',
            bgColor: '#b1f7d3',
            label: t('groupings.submitted')
        }
    }

    const openLink = link =>  {
        downloadLinkClick(id);
        window.open(link,'_blank');
    };

    const openPdfView = link => {
        setPdfDialog(true);
        setPdfFile(link);
    };

    const closePdfdialog = () => {
        setPdfDialog(false);
        setPdfFile('');
    };

    const fileName = file ? getFileName(file) : '';
    const isPdf = fileName ? fileName?.includes(fileName) : false;

    return(
        <div className={classes.docContentView}>
            {fileType === 'task' ?
            <>
                <div className={`${classes.taskStatus} ${isRTL === 'ar' ? classes.statusLeft : classes.statusRight}`}
                    style={{
                        fontFamily,
                        backgroundColor: taskStatusColors?.[taskStatus]?.['bgColor'] || '#f7e9b2',
                        color: taskStatusColors?.[taskStatus]?.['color'] || '#bf8917',
                        border: `2px solid ${taskStatusColors?.[taskStatus]?.['border'] || '#fdd359'}`
                    }}
                >{taskStatusColors?.[taskStatus]?.['label'] || t('groupings.pending')}</div>
                {dueDate ?
                <div className={classes.rowDiv}>
                    <span style={{fontFamily,fontWeight:500}} className={classes.taskTitle}>{t('groupings.dueDate')}</span>
                    <span style={{fontFamily,padding:'0px 3px'}} className={classes.taskTitle}>{moment(new Date(dueDate*1000)).format('D MMMM YYYY')}</span>
                </div>
                : null}

                <div className={classes.rowDiv} style={{marginTop:'20px'}}>
                    <span style={{fontFamily,fontWeight:500}} className={classes.taskTitle}>{t('groupings._task')}</span>
                    <span style={{fontFamily,padding:'0px 3px'}} className={classes.taskTitle}>{name || ''}</span>
                </div>

                <div style={{margin:'20px 0px'}}>
                    <span dangerouslySetInnerHTML={createMarkup(description)}></span>
                </div>

                {file ?
                <>
                <span style={{fontFamily,fontWeight:'bold',marginTop:'30px'}} className={classes.taskTitle}>{t('groupings.attachments')}</span>
                <div className={classes.rowDiv} style={{alignItems:'center',marginTop:'8px'}}>
                    <div className={classes.taskFileIcon}>
                        <img src={DocLogo} alt="doc" />
                    </div>
                    <span style={{fontFamily}} className={`${classes.taskTitle} ${classes.fileName}`}>{fileName}</span>
                    <button className={classes.downloadBtn} style={{fontFamily,color:'#36ABEF',fontSize:'14px',padding:'0px 10px',...(!singleSession && !bookingContent ? {pointerEvents:'none'} : {})}} onClick={()=> window.open(file,"_blank")}>{t('company-setting.billing.sub-title6')}</button>
                </div>
                </>
                : null}
            </>
            :
            <>
                <div className={`${classes.rowDiv}`} style={{alignItems:'center'}}>
                    <div className={classes.docContentIcon}>
                        <img src={fileType === 'document' ? DocLogo : fileType === 'externalLink' ? LinkLogo : fileType === 'text' ? TextIcon : fileType === 'task' ? TaskIcon : LinkLogo} alt={name} />
                    </div>

                    <div className={`${classes.colDiv} ${RTLMar45}`}>
                        <span className={classes.docViewTitle} style={{fontFamily}}>{fileType === 'document' ? t && t('courses.document') : fileType === 'externalLink' ? t && t('courses.exLink') : fileType === 'text' ? t && t('groupings.text') : fileType === 'task' ? t && t('groupings.task') : ''}</span>
                        {showName ? <span className={classes.docViewTitle} style={{fontFamily,color:'#8690A4'}}>{name}</span> : null}
                    </div>
                </div>
                {['externalLink','document']?.includes(fileType) ?
                <div className={classes.colDiv} onClick={()=> isPdf && fileType === 'document' && protectFile ? openPdfView(file) : openLink(file)} style={{justifyContent:'center',alignItems:'center',cursor:'pointer',...(!singleSession && !bookingContent ? {pointerEvents:'none'} : {})}}>
                    <div className={classes.downLogo}>
                        <img src={fileType === 'externalLink' ? OpenLinkLogo : fileType === 'document' ? isPdf && protectFile ? PdfIcon : DownloadLogo : DownloadLogo} alt={name} />
                    </div>

                    <span className={classes.docLinkOpenSpan} style={{fontFamily}}>{fileType === 'document' ? isPdf && protectFile ? t('coursePage.openFile') : t && t('coursePage.clickDownload') : fileType === 'externalLink' ? t && t('coursePage.clickOpenLink') : ''}</span>
                </div>
                :
                fileType === 'text' ?
                <div style={{marginTop:'30px'}}>
                    <span  dangerouslySetInnerHTML={createMarkup(text)}></span>
                </div>
                : null}
            </>
            }

            {openPdfDialog && pdfFile ?
            <PdfFullScreenDialog
                open={openPdfDialog}
            >
                <PDFViewer 
                    file={pdfFile}
                    closeDialog={closePdfdialog}
                    pdfFileUpdation={pdfFileUpdation}
                    contentLogs={contentLogs || []}
                    contentId={id}
                />
            </PdfFullScreenDialog>
            : null}
        </div>
    )
};

const VideoRender = (props) => {
    const { file, contentId, studentName, studentEmail, updateContentDurationEvent, duration, customCls, bookingContent=false } = props;
    const classes = useStyles();
    const playerRef = React.useRef(null);
    const [blobUrl,setBlob] = useState('');

    useEffect(()=> {
        async function run() {
            setBlob('');
            try{
                let signUrl = await generateContentSignedUrl({url:file});
                setBlob(signUrl);
            }
            catch(e){
                console.log('error',e)
            };
        };

        run();
    },[file])

    const videoJsOptions = {
        autoplay: false,
        controls: true,
        responsive: true,
        fluid: true,
        aspectRatio: '16:9',
        studentName,
        studentEmail,
        sources: [{
            src: blobUrl,
            type: 'video/mp4'
        }]
    };

    const handlePlayerReady = (player) => {
        playerRef.current = player;
  
        player.on('dispose', () => {
            const startTime = player.currentTime();
            updateContentDurationEvent(startTime,contentId);
        });

        player.on('pause',()=> {
            const startTime = player.currentTime();
            updateContentDurationEvent(startTime,contentId);
        });

        player.on('ended', () => {
            updateContentDurationEvent(0,contentId,true);
        });
    };
  
    if(blobUrl)
    return (
        <VideoJS
            options={videoJsOptions}
            onReady={handlePlayerReady}
            studentName={studentName}
            studentEmail={studentEmail}
            duration={duration}
            customCls={customCls || ''}
            bookingContent={bookingContent}
        />
    );

    return (
        <div className={classes.docContentView} style={{alignItems:'center',justifyContent:'center'}}>
            <ColorCircularProgress />
        </div>
    );
};

function getFirstVisibleContentInfo(sections, contents) {
    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];
      for (let j = 0; j < section?.contentList?.length; j++) {
        const contentId = section?.contentList[j];
        const content = contents?.find(item => item?.id === contentId);
        if (content && content?.visible) {
          return { sectionId: section?.id, contentId: contentId };
        }
      }
    }
    return null; // Return null if no visible content is found
}

// extract file name from url
export const getFileName = (url) => {
    var startStr = "_ss_";
    var endStr = "?alt=";

    var startIndex = url.indexOf(startStr) + startStr.length;
    var endIndex = url.indexOf(endStr);

    var extractedString = startIndex !== -1 && endIndex !== -1 ? url.substring(startIndex, endIndex) : url;
    return decodeURIComponent(extractedString);
};

const PdfFullScreenDialog = ({open,children}) => (
    <div>
      <Dialog fullScreen open={open} TransitionComponent={Transition}>
        {children}
      </Dialog>
    </div>
);

export {
    VideoRender,
    ContentDocumentView
};